module.exports = __webpack_public_path__ + "img/b_14.357aac54.jpg";